var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHangoutButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 35,
    viewBox: "0 0 60 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15438",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15438",
    transform: "translate(-18868 -4263)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9405",
    "data-name": "\\u9577\\u65B9\\u5F62 9405",
    width: 60,
    height: 35,
    transform: "translate(18868 4263)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15436",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15436",
    transform: "translate(18868 4267)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_8875",
    "data-name": "\\u9577\\u65B9\\u5F62 8875",
    width: 60,
    height: 30.374,
    rx: 15.187,
    transform: "translate(0 -2)",
    fill: "#e83e9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    d: "M21.8,11.521A15.547,15.547,0,0,0,.393,11.53,1.339,1.339,0,0,0,0,12.486a1.306,1.306,0,0,0,.393.947l2.2,2.2a1.406,1.406,0,0,0,1.892.021A9.714,9.714,0,0,1,6.728,14.09,1.4,1.4,0,0,0,7.4,12.8V10.367a14.632,14.632,0,0,1,3.7-.346,14.308,14.308,0,0,1,3.7.343V12.8a1.374,1.374,0,0,0,.659,1.3,9.5,9.5,0,0,1,2.256,1.562,1.381,1.381,0,0,0,.938.375,1.341,1.341,0,0,0,.957-.392l2.2-2.2a1.36,1.36,0,0,0-.009-1.922Z",
    transform: "translate(19.652 1.543)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangoutButton);
export default __webpack_public_path__ + "static/media/hangoutButton.5c2597d1326e293ccc96a7d74db8b784.svg";
export { ForwardRef as ReactComponent };